import { render, staticRenderFns } from "./CustomTreeview.vue?vue&type=template&id=3c5184f4&scoped=true"
import script from "./CustomTreeview.vue?vue&type=script&lang=js"
export * from "./CustomTreeview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5184f4",
  null
  
)

export default component.exports